import React, { useState } from 'react';
import Card from '@material-ui/core/Card';
import CardMedia from '@material-ui/core/CardMedia';
import {
  DonutChart, PatientStatus, ImgLazyload,
} from '../index';
import { handleRupee, extractContent } from '../../../../services/helperFunctions';
import { sendEvents } from '../../../../redux/actions/Home';
import KettoPlaceholder from '../../../public/images/default-campaign-picture.jpg';
import RightIcon from '../../../public/images/icon-right.png';
import TaxBenefit from '../../../public/images/tax-benefit.png';

export const FundariserCard = ({
  campaignData,
  isSelected,
  currency = '',
  handlePopup,
}) => {
  const extractedText = campaignData && campaignData.about && campaignData.about.info_1 ? extractContent(campaignData.about.info_1) : '';
  const taxBenefit = !!(campaignData && campaignData.beneficiary && campaignData.beneficiary.tax_benefit == true);
  return (
    <Card className={`allocate-fund-card ${isSelected ? 'selected' : ''}`} onClick={() => handlePopup(campaignData)}>
      {taxBenefit && <ImgLazyload src={TaxBenefit} className="tax-benefit" />}
      <CardMedia
        className="fundraiser-img"
        image={campaignData.gallery && campaignData.gallery[0] ? campaignData.gallery[0].cdn_path : KettoPlaceholder}
        title="Fundaraiser photo" />
      <div className="content">
        <div className="d-flex cursor-pointer" onClick={() => handlePopup(campaignData)}>
          <p className="mb-0 text-bold mb-1 w-100">
            {campaignData.title && campaignData.title.length > 58 ? `${campaignData.title.slice(0, 58)}...` : campaignData.title}
          </p>
          <ImgLazyload className="cursor-pointer" src={RightIcon} style={{ width: '6px', height: '13px', margin: '10px 5px' }} />
        </div>
        <p className="fs-14 mb-0 lh-20">
          {extractedText.length > 77 ? `${extractedText.slice(0, 77)}...` : `${extractedText}`}
          {extractedText.length > 77 && (
            <span
              className="text-blue cursor-pointer"
              onClick={() => {
                sendEvents('read_more_cta', 'sip_returning', 'allocate_fundraiser', 'impact', '', true);
                handlePopup(campaignData);
              }}>
              Read more
            </span>
          )}
        </p>
      </div>
      <div className="fund-raised">
        <div className="raised">
          <p className="fs-12 amount-titile mb-0">Raised Amount</p>
          <p className="mb-0 fs-12 text-bold">
            ₹&nbsp;
            {campaignData && campaignData.raised && handleRupee(campaignData.raised.raised)}
          </p>
        </div>
        <div className="goal">
          <p className="fs-12 amount-titile mb-0">Goal Amount</p>
          <p className="mb-0 fs-12 text-bold">
            ₹&nbsp;
            {currency && handleRupee(campaignData.amount_requested)}
          </p>
        </div>
        <div className="ml-auto" style={{ width: '48px', height: '48px', marginLeft: 'auto' }}>
          {campaignData.raised && (
            <DonutChart
              lineWidth="25"
              percent={((campaignData.raised.raised / campaignData.amount_requested) * 100) > 100 ? ((campaignData.raised.raised / campaignData.amount_requested) * 100).toFixed(0) : ((campaignData.raised.raised / campaignData.amount_requested) * 100).toFixed(1)}
              data={
                [
                  {
                    value: ((campaignData.raised.raised / campaignData.amount_requested) * 100) > 1
                      ? Math.floor(((campaignData.raised.raised / campaignData.amount_requested) * 100))
                      : ((campaignData.raised.raised / campaignData.amount_requested) * 100).toFixed(2),
                    color: ((campaignData.raised.raised / campaignData.amount_requested) * 100) >= 100 ? 'green' : '#e55051',
                  },
                  { value: 100 - ((campaignData.raised.raised / campaignData.amount_requested) * 100), color: '#EEEEEE' },
                ]
              } />
          )}
        </div>
      </div>
      {campaignData.patientstatus && campaignData.patientstatus.length > 0
        && (
          <div style={{ padding: '10px' }}>
            <PatientStatus status={campaignData.patientstatus[0].pstatus_2} />
          </div>
        )}
    </Card>
  );
};
export default FundariserCard;
